var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 2.26111C12.3672 1.91296 11.6328 1.91296 11.0287 2.26111L4.0287 6.29559C3.94576 6.3434 3.86694 6.3968 3.79257 6.45521L12 11.1856L20.2074 6.45521C20.1331 6.3968 20.0542 6.3434 19.9713 6.29559L12.9713 2.26111Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9765 7.79211L12.75 12.5335V22C12.8253 21.9684 12.8992 21.9318 12.9713 21.8903L19.9713 17.8558C20.6062 17.4898 21 16.7956 21 16.042V8.10935C21 8.00215 20.992 7.89614 20.9765 7.79211Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22V12.5335L3.02347 7.79211C3.00797 7.89614 3 8.00215 3 8.10935V16.042C3 16.7956 3.39378 17.4898 4.02871 17.8558L11.0287 21.8903C11.1008 21.9318 11.1747 21.9684 11.25 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.c936559678be653cd5e740dce72d5ccd.svg";
export { ForwardRef as ReactComponent };